export default __webpack_public_path__ + "static/media/OptimusPrinceps.20e67508.ttf";